export const loadEmperiaSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Check if SDK is already loaded
    if (window.emperia) {
      resolve();
      return;
    }

    console.log('process.env.REACT_APP_SDK_URL', process.env.REACT_APP_SDK_URL);

    // Get SDK URL from environment variable
    const sdkUrl =
      process.env.REACT_APP_SDK_URL ||
      'https://sdk.emperiavr.com/Development/Dashboard/emperia-sdk.min.js';

    // Create script element
    const script = document.createElement('script');
    script.type = 'module';
    script.async = true;
    script.src = sdkUrl;

    // Handle script load success
    script.onload = () => {
      // Wait a bit for the SDK to initialize
      setTimeout(() => {
        if (window.emperia) {
          resolve();
        } else {
          reject(new Error('Emperia SDK failed to initialize'));
        }
      }, 100);
    };

    // Handle script load error
    script.onerror = () => {
      reject(new Error(`Failed to load Emperia SDK from ${sdkUrl}`));
    };

    // Append script to document head
    document.head.appendChild(script);
  });
};
